import styles from './resolutionMobile.module.css';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, TextField } from "@mui/material";
import { Minus, Plus, UploadCloud, X } from "react-feather";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-smart-toaster';

const ResolutionMobile = ({ isPanelOpen, onToggle, requestData, setLoading, setRequestData }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [descVal, setDescVal] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState(0);
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [isResolved, setIsResolved] = useState(false);
  const [inputValue, setInputValue] = useState("0:00");
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (requestData) {
      setDescVal(requestData?.resolution);
      if (requestData?.spent_time) {
        setTime(parseInt(requestData?.spent_time));
      }

      if (requestData?.current_status && (requestData?.current_status === 3 || requestData?.current_status === 5)) {
        setIsResolved(true);
      }
    }
  }, [requestData]);

  useEffect(() => {
    const handler = setTimeout(async () => {

      if (descVal !== '' && requestData?.id) {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, { resolution: descVal }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {

          setRequestData(prev => {
            return { ...prev, resolution: response.data.data?.resolution };
          });


        }).catch(() => { });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [descVal, getAccessTokenSilently]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setRequestData(prev => {
        if (deleteType === 1) {
          let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
          return { ...prev, resolve_images: images };
        } else {
          let images = prev?.images?.filter(i => i?.id !== deleteId);
          return { ...prev, images: images };
        }
      });

      let logData = {
        'title': 'Maintenance resolution image deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => { });
  }

  const fileHandler = async (e) => {
    let extErr = false;
    let sizeErr = false;
    let files = e.target.files;
    let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

    if (files.length > 0) {
      if (allowedExtensionArr.length > 0) {
        let fileName = files[0].name;
        let fileSize = files[0].size;
        let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        fileNameExt = '.' + fileNameExt;

        if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
          extErr = true;
        }

        if (fileSize >= 5242880) {
          sizeErr = true;
        }
      }
    }

    if (extErr) {
      toast.error("File type is not allowed.");
      return false;
    }

    if (sizeErr) {
      toast.error("File size should not be greater than 5 MB.");
      return false;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);

    let formData = new FormData();
    formData.append("image", files[0]);

    axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/resolve-files/upload', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);


      setRequestData(prev => {
        let images = response.data.data.concat(prev?.resolve_images);
        return { ...prev, resolve_images: images };
      });

      let logData = {
        'title': 'Maintenance request resolution image uploaded',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);

    }).catch(error => {
      setLoading(false);
    });
  }

  const formatTime = (mins) => {
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  }

  const updateTime = () => {
    const elapsedMs = Date.now() - startTimeRef.current;
    const elapsedMinutes = Math.floor(elapsedMs / 60000);
    setTime(elapsedMinutes);
  }

  /*const handleStartStop = () => {
    if (isRunning) {
      clearInterval(intervalRef.current);
      setIsRunning(false);
    } else {
      intervalRef.current = setInterval(() => {
        setTime((prev) => prev + 1);
      }, 60000);
      setIsRunning(true);
    }
  }*/

  const handleStartStop = () => {
    if (isRunning) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsRunning(false);
    } else {
      startTimeRef.current = Date.now() - time * 60000;
      updateTime();
      intervalRef.current = setInterval(updateTime, 60000);
      setIsRunning(true);
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && isRunning) {
        updateTime();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    const updateTime = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, { spent_time: time }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(() => {
        /* setRequestData(prev => {
           return { ...prev, spent_time: time };
         });*/
      }).catch(() => { });
    }

    if (time > 0 && requestData?.id)
      updateTime();
  }, [time, requestData?.id]);

  const chkChange = async (e) => {
    if (!requestData?.resolution && time === 0) {
      toast.error("Please add the resolution description and the time spent before resolving this request.", {
        timeout: 4000000,
        fadeOutTimer: 10000000, // override global value
      });
      return false;
    } else if (!requestData?.resolution) {
      toast.error("Please add the resolution description before resolving this request.");
      return false;
    } else if (time === 0) {
      toast.error("Please add the time spent before resolving this request.");
      return false;
    }

    setIsResolved(e?.target?.checked);
    let current_status = 2;
    if (e?.target?.checked) {
      current_status = 5;
      setIsRunning(false);
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-resolve/" + requestData?.id, { current_status: current_status }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setRequestData(prev => {
        return { ...prev, current_status: current_status };
      });

      if (current_status === 3) {
        let logData = {
          title: "A maintenance request has been solved",
          description: [
            "Name: " + response.data.data.title,
            "Request number: " + response.data.data.request_no,
            "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
            "Tenant: " + response.data.data.tenant_name,
            "Technician: " + response.data.data.technician_name,
          ],
        };
        AddLogCallAPI(logData, token);
      }
    }).catch(() => { });
  }

  useEffect(() => {
    setInputValue(formatTime(time));
  }, [time]);

  const parseTime = (value) => {
    if (!value) return 0;
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 2) return parseInt(digits || "0", 10);
    const minutes = parseInt(digits.slice(-2), 10);
    const hours = parseInt(digits.slice(0, -2), 10);
    return hours * 60 + minutes;
  }

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setInputValue(value);
    setTime(parseTime(value));
  }

  return (<>
    <div className={`${styles.AccordionList}`}>
      <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("one")}>
        <p className={`${styles.Title}`}>Resolution</p>
        <img src="/static/img/downTriangle.svg" alt='' />
      </div>
      <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
        <div className={`${styles.AccouFormGroup}`}>

          <div className={`${styles.TimerSec}`}>
            <label className={`${styles.FilterLabel} ${styles.TextCenter}`}>Duration</label>
            <div className={`${styles.TimerFieldSec}`}>
              <button onClick={(e) => setTime((prev) => Math.max(0, prev - 1))} disabled={time === 0 || isResolved}><Minus /></button>
              <input type="text" value={inputValue} onChange={handleChange} placeholder="0:00" inputMode="numeric" />
              <button onClick={(e) => setTime((prev) => Math.max(0, prev + 1))} disabled={isResolved}><Plus /></button>
            </div>
            <div className={`${styles.AddTimeSec}`}>
              <button onClick={(e) => setTime((prev) => Math.max(0, prev + 15))} disabled={isResolved}>+0:15</button>
              <button onClick={(e) => setTime((prev) => Math.max(0, prev + 60))} disabled={isResolved}>+1:00</button>
              <button onClick={(e) => setTime((prev) => Math.max(0, prev + 30))} disabled={isResolved}>+0:30</button>
              <button onClick={(e) => setTime((prev) => Math.max(0, prev + 120))} disabled={isResolved}>+2:00</button>
            </div>
            <p className={`${styles.TimerText}`}>Leave blank to start a timer.</p>

            {!isRunning && <button className={`${styles.TimerStartBU}`} disabled={isResolved} onClick={(e) => handleStartStop()}>Start</button>}
            {isRunning && <button className={`${styles.TimerStopBU}`} onClick={(e) => handleStartStop()}><img src="/static/img/animatedClock.svg" alt="" />Stop</button>}
          </div>

          <form>
            <div className={`${styles.ReqAddRow}`}>
              <div className={`${styles.ReqAddFormSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <label className={`${styles.FilterLabel}`}>Describe the Resolution</label>
                    <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal}
                      onChange={(e) => {
                        setDescVal(e.target.value);
                      }} />
                  </div>
                </div>
                <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                  <label className={`${styles.FilterLabel}`}>Share a Documents/Photos</label>
                  <div className={`${styles.FileIMGDiv}`}>
                    <div className={`${styles.FileUpDuBUDiv}`}>
                      {requestData?.resolve_images?.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload-res"><UploadCloud /> Upload Documents/Photos</label>)}
                      <input id="file-upload-res" type="file" multiple onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                      {requestData?.resolve_images?.length === 0 && (<p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG, PDF, DOC, XLS file only</p>)}
                    </div>

                    <div className={`${styles.UpIMGSec}`}>
                      {requestData?.resolve_images?.map((item, index) => {
                        return (<div className={`${styles.ImgFile}`}>
                          {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/docIcon.png" alt='' />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/excelIcon.png" alt='' />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                            <img src="/static/img/pdfIcon.png" alt='' />
                            <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                          </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" />)))}
                          <Button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(1); }}> <X /> </Button>
                        </div>)
                      })}
                      {requestData?.resolve_images?.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload-res"><Plus /></label>)}
                      {requestData?.resolve_images?.length === 0 && (<div className={`${styles.NoImgDiv}`}>
                        <img src="/static/img/no-photo.png" alt='' />
                      </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.FormGroupFull} FormGroup checkbox`}>
              <FormControlLabel control={<Checkbox checked={isResolved} onChange={(e) => chkChange(e)} />} label="Mark as Resolved" />
            </div>
          </form>
        </div>
      </div>
    </div>

    <Dialog
      open={openDeleteModal}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setOpenDeleteModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to delete the image?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The image will be removed immediately. You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => deleteConfirm()}>Delete</Button>
        <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  </>)
}

export default ResolutionMobile;
